import _ from 'underscore';

// please in uppercase characters
// please sort alphabetically
const errorCodes = [
  'ASSETDATAENCODINGINVALID',
  'AUTHORIZATIONEXPIRE',
  'BINGPREVIEWAPIERROR',
  'CAMPAIGNINLINEEDITORIALERROR',
  'CANNOTLINKUNPUBLISHEDFBPAGE',
  'CCMTERRORNUMBER_POSTPAYACCOUNTCANTASSOCIATEWITHPREPAIDCARD',
  'DUPLICATEENTITY',
  'ENTITYDOESNOTEXIST',
  'ENTITYALREADYEXISTS',
  'EXCEEDACCOUNTGOALLIMIT',
  'EXCEEDDAILYBUDGETLIMIT',
  'EXCEEDTHELIMIT',
  'EXPANDEDTEXTADINLINEEDITORIALERROR',
  'FACEBOOKAPIUSERERROR',
  'FACEBOOKOBJECTNOTEXISTORMISSINGPERMISSIONSERROR',
  'GOALHAVEDUPLICATENAME',
  'GOALHAVEDUPLICATEURLANDOPERATOR',
  'HASINVALIDEXCLAMATIONMARKSYMBOL',
  'HASINVALIDXSSCHARACTERS',
  'INSUFFICIENTPERMISSIONORNEEDENABLE2FA',
  'INVALIDACTION',
  'INVALIDACTIONONSMARTPAGEASSOCIATEDMCACAMPAIGN',
  'INVALIDBUSINESSNAME',
  'INVALIDDESTINATIONGOALOPERATOR',
  'INVALIDKEYWORDTEXT',
  'INVALIDPARAMETER',
  'INVALIDVALUE',
  'INVALIDZIPCODE',
  'KEYWORDINLINEEDITORIALERROR',
  'LINKEDINAPIERROR',
  'LOCATIONNOTEXIST',
  'LOCATIONNOTSUPPORTED',
  'MEDIASIZEEXCEEDLIMIT',
  'NEEDADMINPERMISSION',
  'NEEDBUSINESSADMINPERMISSION',
  'NEEDBUSINESSVERFICATION',
  'NEEDBUSINESSVERIFICATION',
  'NOTALLOWEDADSINFB',
  'PAYMENTNOTSET',
  'PROFILEALREADYLINKED',
  'REMAININGBUDGETLESSTHANMINIMUMBUDGET',
  'SMARTPAGEINVALIDSTATUS',
  'SMARTPAGEINVALIDSUBDOMAIN',
  'SMARTPAGESUBDOMAINISNOTAVAILABLE',
  'SMARTPAGEGETFBPAGEUSERERROR',
  'SMARTPAGEGETFBPAGEOAUTHERROR',
  'TIMEZONENOTMATCH',
  'TOKENEXPIRED',
  'TOKENNOTMATCHTOPROFILE',
  'TWITTERAPIERROR',
  'TWITTERAPIUSERERROR',
  'UNSUPPORTEDWEBSITEDOMAIN',
  'URLNOTACCESSIBLE',
  'TOOMANYIMAGEFORFACEBOOK',
  'TOOMANYGIFFORFACEBOOK',
  'TOOMANYVIDEOFORFACEBOOK',
  'TOOMANYIMAGEFORTWITTER',
  'TOOMANYGIFFORTWITTER',
  'TOOMANYVIDEOFORTWITTER',
  'TOOMANYIMAGEFORINSTAGRAM',
  'TOOMANYIMAGEFORLINKEDIN',
  'TOOFEWIMAGEFORINSTAGRAM',
  'TWITTERSTATUSNOTFOUND',
  'GIFNOTSUPPORTEDFORINSTAGRAM',
  'VIDEONOTSUPPORTEDFORINSTAGRAM',
  'GIFNOTSUPPORTEDFORLINKEDIN',
  'VIDEONOTSUPPORTEDFORLINKEDIN',
  'MEDIASIZEEXCEEDLIMITFORFACEBOOK',
  'MEDIASIZEEXCEEDLIMITFORTWITTER',
  'MEDIASIZEEXCEEDLIMITFORINSTAGRAM',
  'MEDIASIZEEXCEEDLIMITFORLINKEDIN',
  'DUPLICATEPOST',
  'CANNOTSHAREPOST',
  'ERRORPOSTLINK',
  'CANNOTSHARELINK',
  'VIDEODURATIONTOOLONG',
  'POSTEXCEEDSMAXCHARACTERCOUNT',
  'ACCOUNTSUSPENDED',
  'EXCEEDINSTAGRAMPUBLISHAPIRATELIMIT',
  'MEDIANOTREADYFORPUBLISH',
  'INVALIDASPECTRATIO',
  'ACCOUNTRESTRICTED',
  'EXCEEDSMAXNUMBEROFTAGS',
  'UNSUPPORTEDVIDEOFORMAT',
  'UNSUPPORTEDIMAGEFORMAT',
];

export const expectedErrorCodes = _.chain(errorCodes)
  .map(errorCode => errorCode.trim().toUpperCase())
  .value();

export function isExpectedErrorCodes(errorResponseJson) {
  if (_.isEmpty(errorResponseJson)) {
    return false;
  }
  const errorCodesInResponse = _.chain(errorResponseJson)
    .pluck('Code')
    .compact()
    .map(code => code.trim().toUpperCase())
    .uniq()
    .value();

  if (_.isEmpty(errorCodesInResponse)) {
    return false;
  }

  for (let index = 0; index < errorCodesInResponse.length; index += 1) {
    if (!_.contains(expectedErrorCodes, errorCodesInResponse[index])) {
      return false;
    }
  }
  return true;
}

// TODO(ISO: 3820358, 3822889) Remove this after MT updates error code
export function isContainError(error, expectedErrorCode) {
  const expectedCodeUpperCase = expectedErrorCode.toUpperCase();
  const filteredError = _.pluck(error.Errors, 'Code')
    .map(code => code.trim().toUpperCase())
    .find(code => code === expectedCodeUpperCase);
  return !!filteredError;
}

export function getServerErrorMessage(error) {
  let warningMessage;
  if (error && _.size(error.Errors) > 0 && error.Errors[0].Message) {
    warningMessage = error.Errors[0].Message;
  }
  return warningMessage;
}
